
const Footer = () => {
  return (
    <footer className="bg-transparent text-center text-sm text-gray-600 py-10 px-4 border-t border-gray-200">
        <div className="mb-2">
            Privacy Policy        |
            Terms & Conditions
        </div>
        {/* <p className="max-w-3xl mx-auto mb-2 leading-relaxed">
            This website is not affiliated with Facebook Inc. or the Facebook website. Furthermore, Facebook does not in any way support
            this website. Facebook, Inc. is the owner of the trademark FACEBOOK.
            
        </p> */}

        <div className="">All rights reserved. © 2025 nxtamedia.com</div>
    </footer>
  );
};

export default Footer;
